import { Divider, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import TextFieldInput from "../../../../components/TextFieldInput";
import SelectInput from "../../../../components/SelectInput";
import { removeBlobImages } from "../../../../utilis/common-funtions";
import UploadInput from "../../../../components/UploadInput";
import UploadPopup from "../../../../shared-components/upload-popup/UploadPopup";

const CancellationDetails = ({ paymentOptionsFormik }) => {
  const [showUploadPopup, setShowUploadPopup] = useState(false);

  const handleImageValue = (keyName, imgName) => {
    removeBlobImages();
    paymentOptionsFormik.setFieldValue(keyName, imgName);
  };

  const togglePopup = () => {
    removeBlobImages();
    setShowUploadPopup(!showUploadPopup);
  };

  return (
    <div>
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        Your Bank details in case of Refund:      </Typography>

      <Grid container spacing={2} mt={0}>
        <Grid item xs={12} sm={6}>
          <TextFieldInput
            field={{
              name: "cancellationPayeename",
              label: "Payee Name",
              required: true,
              readonly: false,
              placeholder: "Enter Payee Name",
            }}
            formik={paymentOptionsFormik}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextFieldInput
            field={{
              name: "cancellationBankname",
              label: "Bank Name",
              required: true,
              readonly: false,
              placeholder: "Enter Bank Name",
            }}
            formik={paymentOptionsFormik}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} mt={0}>
        <Grid item xs={12} sm={6}>
          <TextFieldInput
            field={{
              name: "cancellationIfscCode",
              label: "IFSC Code",
              required: true,
              readonly: false,
              placeholder: "Enter IFSC Code",
            }}
            formik={paymentOptionsFormik}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextFieldInput
            field={{
              name: "cancellationAccountNo",
              label: "Account Number",
              required: true,
              readonly: false,
              placeholder: "Enter Account Number",
            }}
            formik={paymentOptionsFormik}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} mt={0}>
        <Grid item xs={12} sm={6}>
          <SelectInput
            field={{
              name: "cancellationAccountType",
              label: "Account Type",
              required: true,
              readonly: false,
              options: [
                { name: "Savings", value: "Savings" },
                { name: "Current", value: "Current" },
              ],
              placeholder: "Select Account Type",
            }}
            formik={paymentOptionsFormik}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <UploadInput
            field={{
              name: "cancelledCheque",
              label: "Upload Cancelled Cheque or Bank Statement",
              placeholder: paymentOptionsFormik?.values
                ?.isPhysicalCancelledCheque
                ? "Upload Later"
                : "Upload Cancelled Cheque or Bank Statement",
              placeholderUpload: "Upload Successful",
              required: true,
              handleOnClick: togglePopup,
              physicalCopyValue:
                paymentOptionsFormik?.values?.isPhysicalCancelledCheque,
            }}
            formik={paymentOptionsFormik}
          />
          <Typography sx={{ fontSize: '12px', color: '#9B9EAB', mt: 0.3 }}>Account holder&apos;s name required on the document.</Typography>
          {showUploadPopup && (
            <UploadPopup
              heading="Upload Cancelled Cheque or Bank Statement"
              totalImages={1}
              closePopup={togglePopup}
              handleImageValue={handleImageValue}
              uploadedImage={paymentOptionsFormik?.values?.cancelledCheque}
              fieldName="cancelledCheque"
              handleUpdateImageData={(fieldName, imageData) => {
                paymentOptionsFormik.setFieldValue(fieldName, imageData);
              }}
              handlePhysicalImage={(_, value) => {
                paymentOptionsFormik.setFieldValue(
                  "isPhysicalCancelledCheque",
                  value
                );
              }}
              selectedOptionValue={
                paymentOptionsFormik?.values?.isPhysicalCancelledCheque
              }
              dynamicSize={2}
              fileType="both"
            />
          )}
        </Grid>
      </Grid>

      <Divider sx={{ mt: 2, mb: 1, border: "1px dashed #DADADA" }} />
    </div>
  );
};

export default CancellationDetails;
